export const getOSType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    if (/android/i.test(userAgent)) {
      return 'android';
    }
  
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
  
    return 'Web';
  };


export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toUpperCase() : word.toLowerCase();
  }).replace(/\s+/g, '');
}

export const dateConvert = (date) => {
  const rawDate = date;
  const dateObj = new Date(rawDate);
  const formattedDate = dateObj.toLocaleDateString('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric'
  });

  return formattedDate;
}

 export const handleDownload = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'certificate.pdf');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const isEncrypted = (str, src, clnt) => {
  try {
    console.log("strstr",str);
    console.log("srcsrc",src);
    console.log("clnt",clnt);

    if(!src){
      src  = JSON.parse(localStorage.getItem('src') || '""');
    }

    if(!clnt){
      clnt = JSON.parse(localStorage.getItem('clnt') || '""');
    }

    console.log("src from local",src);
    console.log("clnt from local",clnt);
    // Try decoding Base64
    const decoded = atob(str);

    // Check if decoded string has a reasonable length (AES block size is 16 bytes)
    const verified = decoded.length >= 16;

    // Default request
    let request = { mobile: str, web: true };

    // If encrypted, update web flag
    if (verified) {
      request.web = false;
    }

    // If src is provided, add it to the request
    if (src) {
      request.src = src;
    }

    // If src is provided, add it to the request
    if (clnt) {
       request.clnt = clnt;
    }
    console.log("requestrequest",request);
    return request;
  } catch (e) {
    // If decoding fails, it's not valid Base64
    return false;
  }
};

export const parseMobileParams = () => {
  const params = new URLSearchParams(window.location.search);
  console.log("paramsparams",params);
  let mobileNumber = params.get('mobile');
  let source = params.get('src');
  let client = params.get('clnt');

  if(source && client){
    localStorage.setItem('clnt', JSON.stringify(client));
    localStorage.setItem('src', JSON.stringify(source));
  }

  if (mobileNumber) {
    mobileNumber = mobileNumber.replace(/ /g, '+');
    const verifiedData = isEncrypted(mobileNumber, source, client);
    return {
      mobileNumber,
      source,
      client,
      verifiedData,
    };
  }

  return null;
};

export const parseMobileParamsNew = () => {

    const params = new URLSearchParams(window.location.search);

    let mobileNumber = params.get('mobile');
    const source = params.get('src');
    const client = params.get('clnt');

    // If mobile not present in query string,
    // get it from URL path
    if (!mobileNumber) {

        const path = window.location.pathname
            .replace(/^\/+|\/+$/g, '');
            console.log("pathpathpath",path);

        if (path) {
            mobileNumber = path;
        }
    }

    if (source) {
        localStorage.setItem('src', JSON.stringify(source));
    }

    if (client) {
        localStorage.setItem('clnt', JSON.stringify(client));
    }

    if (mobileNumber) {

        mobileNumber = mobileNumber.replace(/ /g, '+');

        const verifiedData = isEncrypted(
            mobileNumber,
            source,
            client
        );
        console.log("verifiedDataverifiedData",verifiedData);
        return {
            mobileNumber,
            source,
            client,
            verifiedData
        };
    }
  };



  
